<template>
  <div class="table-container">
    <DataTable :value="data" editMode="cell" @cell-edit-complete="onCellEditComplete"
      class="editable-cells-table primevue-dtable tablepaginator" stripedRows showGridlines responsiveLayout="scroll"
      @update:selection="selectAllHandler" :metaKeySelection="true" @row-click="RowClick"
      v-model:selection="selectedProduct" @row-unselect-all="RowUnSelectAll" @row-unselect="RowUnSelect"
      :paginator="showPagination" :rows="state.pageSize" :rowsPerPageOptions="computedRowsPerPageOptions"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" @page="onPageChange">
      <Column header="#" headerStyle="width:3rem" v-if="seriaNlumber">
        <template #body="slotProps">
          {{ calculateSerialNumber(slotProps.index) }}
        </template>
      </Column>
      <Column selectionMode="multiple" v-if="selectionMode"></Column>

      <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field" :styles="{ width: '25%' }"
        :slot="col.slot" :class="[{ editable: col.class === 'editable' }, col.class]" :selectionMode="col.selectionMode"
        :body-class="col.bodyclass">
        <template #editor="slotProps: any" v-if="col.editable">
          <InputText v-if="col.type == 'InputText'" v-model="slotProps.data[slotProps.column['props'].field]"
            autofocus />
          <Dropdown v-if="col.type == 'Dropdown'" v-model="slotProps.data[slotProps.column['props'].field]" autofocus
            :options="tabledropdown" optionLabel="Name" optionValue="Id" />
          <MultiSelect v-if="col.type == 'MultiSelect'" v-model="slotProps.data[slotProps.column['props'].field]"
            autofocus :options="tabledropdownSelect" optionLabel="Name" optionValue="Id" />
          <AutoComplete v-if="col.type == 'AutoComplete'" v-model="slotProps.data[slotProps.column['props'].field]"
            autofocus />
          <Calendar v-if="col.type == 'Calendar'" v-model="slotProps.data[slotProps.column['props'].field]" autofocus />
          <Checkbox v-if="col.type == 'Checkbox'" v-model="slotProps.data[slotProps.column['props'].field]" autofocus />
          <InputSwitch v-if="col.type == 'InputSwitch'" v-model="slotProps.data[slotProps.column['props'].field]"
            autofocus />
          <Textarea v-if="col.type == 'Textarea'" v-model="slotProps.data[slotProps.column['props'].field]" autofocus
            rows="5" cols="30" />
          <ToggleButton v-if="col.type == 'ToggleButton'" v-model="slotProps.data[slotProps.column['props'].field]"
            autofocus />
        </template>
        <template #body="{ data }">
          {{ data[col.field] }}
          <span :data-header="col.header" class="body-data">
            <slot :name="col.slot" :data="data" :header="col.header"></slot>
          </span>
        </template>
      </Column>
    </DataTable>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed, PropType, watch } from "vue";

export default defineComponent({
  name: "App",
  components: {},
  props: {
    columns: {
      type: Array as PropType<any[]>,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    tabledropdown: {
      type: Array as PropType<any[]>,
    },
    tabledropdownSelect: {
      type: Array as PropType<any[]>,
    },
    selection: {
      type: Array,
    },
    selectionMode: {
      type: Boolean,
      default: false,
    },
    seriaNlumber: {
      type: Boolean,
      default: false,
    },
    paginator: {
      type: Boolean,
      default: false,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    state: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 25
      })
    }
  },

  setup(props, { emit }) {
    const computedRowsPerPageOptions = computed(() => {
      const defaultOptions = [25, 50, 100];
      // return [...defaultOptions, props.data.length];
      return [...defaultOptions];
    });

    const showPagination = computed(() => props.paginator && props.data.length > 25);
    const state = ref({
      currentPage: 1,
      pageSize: 25
    });

    watch(() => props.state, (newValue) => {
      Object.assign(state.value, newValue);
    }, { deep: true });

    function onPageChange(event) {
      state.value.currentPage = event.page + 1;
      state.value.pageSize = event.rows;
      emit('page-change', state.value);
    }

    function onCellEditComplete(event) {
      if (event.field === "SupplierId") {
        const selectedSupplier = event.value;
        console.log(selectedSupplier);
      }
      let { data, newValue, field } = event;
      switch (field) {
        case "quantity":
        case "price":
          if (isPositiveInteger(newValue)) data[field] = newValue;
          else event.preventDefault();
          break;
        default:
          if (newValue.length > 0) data[field] = newValue;
          else event.preventDefault();
          break;
      }
    }

    function isPositiveInteger(val) {
      let str = String(val);
      str = str.trim();
      if (!str) {
        return false;
      }
      str = str.replace(/^0+/, "") || "0";
      var n = Math.floor(Number(str));
      return n !== Infinity && String(n) === str && n >= 0;
    }

    const selectedRow = ref(null);
    const selectedProduct: any = ref([]);

    watch(
      () => props.selection,
      (newVal: any) => {
        selectedProduct.value = newVal;
        update()
      }
    );

    function update() {
      emit("selection", selectedProduct.value);
    }

    function selectAllHandler(event) {
      selectedProduct.value = event;
      update();
    }

    function RowClick(event) {
      emit("row-click", event);
    }

    function RowUnSelectAll(event) {
      emit("row-unselect-all", event);
    }

    function RowUnSelect(event) {
      emit("row-unselect", event);
    }

    function calculateSerialNumber(index: number) {
      return ((state.value.currentPage - 1) * state.value.pageSize) + (index + 1);
    }

    return {
      selectedRow,
      onCellEditComplete,
      selectedProduct,
      update,
      selectAllHandler,
      RowClick,
      RowUnSelectAll,
      RowUnSelect,
      state,
      onPageChange,
      calculateSerialNumber,
      showPagination,
      computedRowsPerPageOptions
    };
  },
});
</script>

<style lang="scss">
@import "../../assets/variables.scss";

.table-container {
  .p-datatable {
    .p-datatable-tbody {
      tr {
        &:nth-child(odd) {
          background-color: #f2f2f2;
        }

        td {
          vertical-align: middle;
          border-color: #c5c5c5;
        }
      }
    }

    .p-datatable-thead {
      background-color: #4caf50;
      color: #fff;
      font-weight: bold;

      th {
        color: rgb(31, 4, 4) !important;
        height: 50px;
        vertical-align: middle;
        border-color: #c5c5c5;

        &:first-child {
          border-top-left-radius: 5px;
        }

        &:last-child {
          border-top-right-radius: 5px;
        }
      }
    }
  }

  .editable {
    color: rgb(179, 179, 196) !important;
  }
}

// Pagination styles
.p-paginator {
  background: #FFFFFF !important;
  border: solid $PPaginatorBorder !important;
  border-width: 1px !important;
  border-radius: 0px !important;
}

.p-paginator-bottom {
  display: flex;
  justify-content: center;
  background: #FFFFFF;
}

.p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 2rem !important;
  height: 2rem !important;
}

.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
  min-width: 2rem !important;
  height: 2rem !important;
}

.pagination-text {
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.pagination-dropdown {
  margin-bottom: 0px !important;
}

.pagination-dropdown .p-inputtext {
  padding: 0.5rem 0.1rem 0.5rem 0.5rem !important;
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.pagination-dropdown .p-dropdown .p-dropdown-trigger {
  width: 2rem;
}

.p-paginator .p-dropdown .p-dropdown-trigger {
  width: 1rem;
  padding-right: 15px;
}

.tablepaginator .p-paginator .p-inputtext {
  padding: 7px !important;
}

.tablepaginator .p-paginator .p-dropdown {
  height: 2rem;
  width: 57px;
}

@media only screen and (max-width: 450px) {

  .p-paginator .p-paginator-first,
  .p-paginator .p-paginator-prev,
  .p-paginator .p-paginator-next,
  .p-paginator .p-paginator-last,
  .p-paginator .p-paginator-pages .p-paginator-page {
    min-width: 1rem !important;
    height: 1rem !important;
  }

  .p-paginator .p-paginator-current {
    min-width: 1rem;
    height: 1rem;
    font-size: 12px;
  }

  .tablepaginator .p-paginator .p-dropdown {
    height: 25px;
    width: 35px;
  }

  .tablepaginator .p-paginator .p-inputtext {
    padding: 5px 2px;
    font-size: 12px;
  }

  .p-paginator .p-paginator-pages .p-paginator-page {
    font-size: 12px;
  }

  .p-paginator .p-dropdown .p-dropdown-trigger {
    width: 0.5rem;
    padding-right: 8px;
  }

  .p-paginator .pi {
    font-size: 10px;
  }
}
</style>
